import { MantineThemeOverride, DEFAULT_THEME } from '@mantine/core';
import COLORS_FLAT from '@styles/colors/themes/beam/beam-flat';
import {
  AnchorDefaultProps,
  ImageDefaultProps,
  PortalDefaultProps,
  TextDefaultProps,
  ButtonDefaultProps,
  CheckboxDefaultProps,
  ScrollAreaDefaultProps,
} from './defaultProps';
import { blackH } from './utils';

const { blue } = DEFAULT_THEME.colors;

/**

Colors:
  - Neutral (50-800);
    0: 50 ,
    1: 75
    2: 100
    3: 200, 4: 300, 5: 400, 6: 500, 7: 600, 8: 700, 9:800.
  - Blue (50-800);
    0: 50 ,
    1: 100 (icon-hover)
    2: 200, 3: 300, 4: 400, 5: 500, 6: 600, 7: 400 (primary) 8: 600, 9:600.
  - Red (50-600);
    0 : 50, 1: 100 , 2: 200, 3: 300 ,  4: 400 (primary danger), 5: 500, 6:  600
Headings:
  - Pattern: Headings start at h1 for figma H-800, h2 : H700 , h3: H600,
    h4: H500, h5: H400, etc. H900 is a special case.

    {@link https://mantine.dev/theming/theme-object/ Mantine Theme object Docs}
*/
export const BTheme: MantineThemeOverride = {
  black: blackH,
  colors: {
    neutral: [
      '#FAFBFD',
      '#F9FAFC',
      '#F4F6FA',
      '#EDEFF4',
      '#E6E8F0',
      '#D8DAE5',
      '#C1C4D6',
      '#8F95B2',
      '#696F8C',
      '#474D66',
    ],
    eblue: [
      '#F3F6FF',
      '#E6EDFF',
      '#D6E0FF',
      '#9DB5FF',
      '#1371FE',
      '#3366FF',
      '#2952CC',
      '#1F3D99',
      '#1F3D99',
      '#1F3D99',
    ],
    blue: [
      blue[0],
      blue[1],
      blue[2],
      blue[3],
      blue[4],
      blue[5],
      blue[6],
      '#1371FE',
      blue[8],
      blue[9],
    ],
    ered: [
      '#FDF4F4',
      '#F9DADA',
      '#F4B6B6',
      '#EE9191',
      '#D14343',
      '#A73636',
      '#7D2828',
      '#7D2828',
      '#7D2828',
      '#7D2828',
    ],
  },
  primaryColor: 'blue',
  primaryShade: 7,
  // Typography
  fontFamily: "'Poppins', sans-serif",
  lineHeight: 1.5,
  headings: {
    fontFamily: "'Poppins', sans-serif",
    sizes: {
      h4: {
        fontSize: 16,
        fontWeight: 600,
        lineHeight: 1.5,
      },
      h5: {
        fontWeight: 500,
        fontSize: 14,
        lineHeight: 1.57,
      },
    },
  },
  focusRingStyles: {
    inputStyles() {
      return {
        '&::placeholder': {
          color: COLORS_FLAT.n700,
        },
      };
    },
  },
  // Components, Defaults
  components: {
    Text: {
      defaultProps: TextDefaultProps,
    },
    Anchor: {
      defaultProps: AnchorDefaultProps,
    },
    Portal: {
      defaultProps: PortalDefaultProps,
    },
    Image: {
      defaultProps: ImageDefaultProps,
    },
    Button: {
      defaultProps: ButtonDefaultProps,
    },
    Checkbox: {
      defaultProps: CheckboxDefaultProps,
    },
    ScrollArea: {
      defaultProps: ScrollAreaDefaultProps,
    },
  },
};
